import { ResourceType } from '../models/api';
import { Label } from './englishLabels';
import { beautifyCamelCaseString } from '../common/stringUtils';
import { ActionTypes } from '../models/api/playbooks/actions/actionTypes.enum';

export const tableSidePanelShortcuts = (itemType: string) =>
  `Use <kbd>↑</kbd> / <kbd>↓</kbd> to move to previous/next ${itemType}. <kbd>Esc</kbd> to close panel`;

export const buildResourceTypeDisplayName = (resourceType?: ResourceType): string => {
  if (!resourceType) {
    return '';
  }

  switch (resourceType) {
    case ResourceType.copilot:
      return Label.get('zenityCommon.resourceTypeDisplayNames.copilot');
    case ResourceType.copilot_action:
      return Label.get('zenityCommon.resourceTypeDisplayNames.copilotAction');
    case ResourceType.copilot_knowledge:
      return Label.get('zenityCommon.resourceTypeDisplayNames.copilotKnowledge');
    case ResourceType.copilot_topic:
      return Label.get('zenityCommon.resourceTypeDisplayNames.copilotTopic');
    default:
      return beautifyCamelCaseString(resourceType);
  }
};

export const buildPlaybookActionTypeDisplayName = (actionType: ActionTypes): string => {
  switch (actionType) {
    case ActionTypes.sendWebhook:
      return Label.get('playbooks.sendWebhookActionDisplayName');
    case ActionTypes.setCopilotAuthentication: {
      return Label.get('playbooks.setCopilotAuthenticationActionDisplayName');
    }
    case ActionTypes.addOwnerToCopilot: {
      return Label.get('playbooks.addOwnerToCopilotActionDisplayName');
    }
    case ActionTypes.removeAccessFromCopilot: {
      return Label.get('playbooks.removeAccessFromCopilotActionDisplayName');
    }
    case ActionTypes.isolateFlowResource: {
      return Label.get('playbooks.isolateFlowResourceActionDisplayName');
    }
    case ActionTypes.isolateCopilotResource: {
      return Label.get('playbooks.isolateCopilotResourceActionDisplayName');
    }
    case ActionTypes.isolateGpt: {
      return Label.get('playbooks.isolateGptActionDisplayName');
    }
    case ActionTypes.isolateWorkspace: {
      return Label.get('playbooks.isolateWorkspaceActionDisplayName');
    }
    case ActionTypes.setAllUsersAccessWorkspace: {
      return Label.get('playbooks.setAllUsersAccessWorkspaceActionDisplayName');
    }
    case ActionTypes.deleteAgent: {
      return Label.get('playbooks.deleteAgentActionDisplayName');
    }
    case ActionTypes.deletePowerBIDataset: {
      return Label.get('playbooks.deletePowerBIDatasetActionDisplayName');
    }
    case ActionTypes.deletePowerBIReport: {
      return Label.get('playbooks.deletePowerBIReportActionDisplayName');
    }
    case ActionTypes.deleteAgentThread: {
      return Label.get('commonActions.deleteAgentThread');
    }
    case ActionTypes.sendToSoc: {
      return Label.get('playbooks.sendToSocActionDisplayName');
    }
    case ActionTypes.setAgentActionAuthenticationMode:
    case ActionTypes.setUserContext:
    case ActionTypes.setAuthorContext: {
      return Label.get('commonActions.authenticationMode.label');
    }
    case ActionTypes.setAgentActionConfirmationMode:
    case ActionTypes.setStrictConfirmationMode:
    case ActionTypes.setDisabledConfirmationMode: {
      return Label.get('commonActions.confirmationMode.label');
    }
    case ActionTypes.setAgentWebBrowsing:
    case ActionTypes.enableWebBrowsing:
    case ActionTypes.disableWebBrowsing: {
      return Label.get('commonActions.webBrowsing.label');
    }
    case ActionTypes.setEnvironmentAudit:
    case ActionTypes.enableEnvironmentAudit:
    case ActionTypes.disableEnvironmentAudit: {
      return Label.get('commonActions.environmentAudit.label');
    }
    default:
      return beautifyCamelCaseString(actionType);
  }
};
